import React from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";
import { postJsonData } from "../../network/ApiController";
import ApiEndpoints from "../../network/ApiEndPoints";
import { okSuccessToast, apiErrorToast } from "../../utils/ToastUtil";

const DeleteInvoiceModal = ({ open, onClose, invoice, onSuccess }) => {
  const handleDelete = () => {
    postJsonData(
      `${ApiEndpoints.DELETE_INVOICE}`,
      { id: invoice?.id },
      "", // Assuming this is request state handler (can be removed or replaced as needed)
      (res) => {
        okSuccessToast(res?.data?.message || "Invoice deleted successfully");
        onSuccess();
      },
      (err) => {
        apiErrorToast("Failed to delete invoice");
      }
    );
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Delete Invoice</DialogTitle>
      <DialogContent>
        <Typography>
          Are you sure you want to delete this invoice for{" "}
          <strong>{invoice?.establishment || "Unknown Establishment"}</strong>?
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="inherit">
          Cancel
        </Button>
        <Button onClick={handleDelete} color="error" variant="contained">
          Delete
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteInvoiceModal;
